import { useEffect } from 'react';
import { useDropdownState } from '@vtex/admin-ui';
import { DropdownProps } from './dropdown.component';

export const useDropdown = ({
  initialSelectedOption,
  label,
  options,
  onChange,
}: DropdownProps) => {
  const state = useDropdownState({
    items: options,
    initialSelectedItem: initialSelectedOption,
  });

  useEffect(() => {
    onChange(state.selectedItem);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return { state };
};
